/**
 * Controllers may return `{ success, data }` while TransformInterceptor wraps again.
 * Unwrap nested success envelopes so callers receive a single `{ success, data: T }`.
 */
export function unwrapNestedApiPayload<T>(body: T): T {
  if (!body || typeof body !== 'object') {
    return body;
  }

  const record = body as Record<string, unknown>;
  if (record['success'] !== true || !('data' in record)) {
    return body;
  }

  let inner: unknown = record['data'];
  while (isSuccessEnvelope(inner)) {
    inner = (inner as Record<string, unknown>)['data'];
  }

  if (inner === record['data']) {
    return body;
  }

  return { ...record, data: inner } as T;
}

function isSuccessEnvelope(value: unknown): value is { success: true; data: unknown } {
  return (
    !!value &&
    typeof value === 'object' &&
    (value as Record<string, unknown>)['success'] === true &&
    'data' in value
  );
}
